import map from 'lodash/map';

import canClockMassShiftEntries from '@/mixins/clocking/mass/canClockMassShiftEntries';

import constants from '@/constants';

export default {
  mixins: [canClockMassShiftEntries],

  methods: {
    createMassShiftClockOut(
      shiftClockOutParameters,
      successCallback,
      lastly,
      errorCallBack = () => {},
    ) {
      const timeEntries = map(
        shiftClockOutParameters,
        (config) => {
          let timeEntryRequest = null;
          this.getBaseTimeEntryRequest(
            constants.EntryType.CLOCK_OUT,
            config.timeZoneOffset,
            false,
            null,
            null,
            (baseTimeEntryRequest) => {
              timeEntryRequest = baseTimeEntryRequest;
              timeEntryRequest.shiftTimePairId = config.shiftTimePairId;
            },
          );
          return timeEntryRequest;
        },
      );

      this.createShiftTimeEntries(timeEntries, successCallback, lastly, errorCallBack);
    },
  },
};
